import { Reveal } from "@/components/Reveal";

export const SectionTag = ({ children, light = false }) => (
  <Reveal>
    <span
      className={`inline-flex items-center gap-2.5 text-xs font-semibold uppercase tracking-[0.18em] ${
        light ? "text-terracotta-light" : "text-terracotta-deep"
      }`}
    >
      <span className="w-8 h-px bg-terracotta" aria-hidden="true" />
      {children}
    </span>
  </Reveal>
);
